import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';

const LoginLayout = ({ children }) => {
  const theme = useTheme();
  return <theme.layout.LoginLayout>{children}</theme.layout.LoginLayout>;
};

LoginLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LoginLayout;
